import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const TabPanel = props => {
  const { children, classes, ...other } = props;

  return (
    <Paper role="tabpanel" {...other} square classes={{ root: classes.paper }}>
      <div className={classes.panel}>{children}</div>
    </Paper>
  );
};

const styles = () => ({
  paper: {
    width: '100%',
  },
  panel: {
    padding: '1em',
  },
});

TabPanel.propTypes = {
  children: PropTypes.node,
};

export default withStyles(styles)(TabPanel);
